// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wave{display:block;max-height:100%;max-width:none}.wave.w-full{width:100%}.wave.h-full{height:100%}.wave--horizontal{min-width:640px;width:calc(var(--win-width)*.75)}.wave--vertical{height:var(--win-height);max-height:none;max-width:100%;min-height:640px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
